module.exports = __webpack_public_path__ + "img/ChampmandiInkBlue.8c0b5ec6.png";